import "./App.css";

function App() {
  return (
    <div className="container">
      <a className="content" href="mailto:info@f37.com">
        <img src="/logo.png" alt="The Modern Game Logo" className="logo" />
      </a>
    </div>
  );
}

export default App;
